<template>
    <app-layout :title="'Survey: ' + surveyModel.name" :survey-layout="true">
        <div class="mt-6 mb-11">
            <h2 class="font-bold text-4xl dark:text-gray-200">
                {{ surveyModel.name }}
            </h2>
        </div>
        <form @submit.prevent="submit">
            <div class="p-6 shadow-md rounded-md mb-10">
                <div class="ck-content text-lg mb-6" v-html="surveyModel.intro_text"></div>
                <template v-if="!form.wasSuccessful">
                    <p class="text-lg font-bold mb-4">
                        To start the survey, please provide your e-mail address. You will receive an email with a link that you can use to resume filling the survey at any time.
                    </p>

                    <div class="block">
                        <span class="block text-lg font-semibold leading-5 mb-2.5">E-mail address</span>
                        <div class="relative">
                            <jet-input type="email"
                                       :required="true"
                                       v-model="form.email"
                                       placeholder="example@email.com"
                            />
                        </div>
                    </div>

                </template>
                <template v-else>
                    <p class="text-lg font-bold">
                        Thank you for starting the fill in process for the survey. Please check your e-mail address and use the provided link to begin.
                    </p>
                </template>
            </div>
            <div v-if="!form.wasSuccessful" class="flex justify-between">
                <jet-button class="ml-auto"
                            :bg-dark="true"
                >
                    Start
                </jet-button>
            </div>
        </form>
    </app-layout>
</template>

<script>
import Survey from "@/Components/Survey";
import AppLayout from "@/Layouts/AppLayout";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "RespondentIdentification",
    components: {AppLayout, Survey, JetButton, JetInput},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        },
        tokenType: {
            type: String,
            required: true,
        }
    },
    setup(props) {
        const form = useForm({
            email: null,
            tokenType: props.tokenType,
            token: props.tokenType === "custom" ? props.surveyModel.custom_url : props.surveyModel.token
        });

        const submit = () => {
            form.post(route('tenant.survey.fill.identify', {tenant: props.surveyModel.tenant_id}));
        }

        return {
            form,
            submit
        };
    }
}
</script>

<style scoped>

</style>
